export default {"src":"/_next/static/media/appStore_120x40.4ee8763b.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};